import { FC, ReactNode } from "react";
import { Button } from "theme";

import { Box, Grid2 } from "@mui/material";
import { styled } from "@mui/material/styles";

export type SubmitButtonProps = {
  disabled?: boolean;
  form: string;
  text?: string;
  loading?: boolean;
  children?: ReactNode;
  skipButton?: ReactNode;
};

// @ts-ignore
const StyledButtonWrap = styled(Box)(({ theme, isChildren }) => {
  return {
    position: "fixed",
    width: "calc(100% - 20px)",
    maxWidth: 580,
    zIndex: 1,
    bottom: isChildren ? 0 : theme.spacing(4),
    left: "50%",
    transform: "translate(-50%, 0)",
    backgroundColor: theme.palette.primary.main,
    borderRadius: isChildren ? 0 : theme.shape.borderRadius,
    paddingBottom: isChildren ? theme.spacing(4) : 0,
  };
});

const SubmitButton: FC<SubmitButtonProps> = ({
  disabled = false,
  form,
  text = "Продовжити",
  loading,
  children = null,
  skipButton = null,
}) => {
  return (
    // @ts-ignore
    <StyledButtonWrap isChildren={!!children}>
      {children}
      <Grid2
        flexDirection="row"
        flexWrap="nowrap"
        container
        justifyContent="space-between"
        alignItems="center"
        columnGap={2}
      >
        {skipButton}
        <Button
          type="submit"
          form={form}
          loading={loading}
          disabled={disabled}
          size="large"
          fullWidth
        >
          {text}
        </Button>
      </Grid2>
    </StyledButtonWrap>
  );
};

export default SubmitButton;
